import * as React from "react";
import type { SVGProps } from "react";
const SvgContract = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    role="img"
    focusable={false}
    {...props}
  >
    <path
      fill="currentColor"
      d="M3.754 3.046a.5.5 0 0 0-.708.708L8.773 9.48H3.4a.5.5 0 0 0 0 1h6.58a.5.5 0 0 0 .5-.5V3.4a.5.5 0 1 0-1 0v5.373zM15.227 14.52H20.6a.5.5 0 1 0 0-1h-6.58a.5.5 0 0 0-.5.5v6.58a.5.5 0 0 0 1 0v-5.373l5.726 5.727a.5.5 0 0 0 .707-.707z"
    />
  </svg>
);
export default SvgContract;
